import { render, staticRenderFns } from "./AgreementDetails.vue?vue&type=template&id=119bb5a2&scoped=true"
import script from "./AgreementDetails.vue?vue&type=script&lang=js"
export * from "./AgreementDetails.vue?vue&type=script&lang=js"
import style0 from "./AgreementDetails.vue?vue&type=style&index=0&id=119bb5a2&prod&scoped=true&lang=css"
import style1 from "./AgreementDetails.vue?vue&type=style&index=1&id=119bb5a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119bb5a2",
  null
  
)

export default component.exports